import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { dictionaries } from "@/lib/i18n-dict";

const I18nContext = createContext({ locale: "en", t: (k) => k, setLocale: () => {} });

const LS_KEY = "ec_locale";

function getByPath(obj, path) {
  return path.split(".").reduce((acc, key) => (acc != null ? acc[key] : undefined), obj);
}

export function I18nProvider({ children }) {
  const [locale, setLocaleState] = useState(() => {
    try {
      const saved = localStorage.getItem(LS_KEY);
      if (saved === "es" || saved === "en") return saved;
    } catch {}
    // Default to English. The primary market is Boston, USA — users can flip
    // to Spanish via the header toggle and the choice is persisted.
    return "en";
  });

  const setLocale = useCallback((next) => {
    setLocaleState(next);
    try { localStorage.setItem(LS_KEY, next); } catch {}
  }, []);

  const t = useCallback((path, vars) => {
    const dict = dictionaries[locale] || dictionaries.en;
    let val = getByPath(dict, path);
    if (val == null) val = getByPath(dictionaries.en, path) ?? path;
    if (typeof val === "string" && vars) {
      Object.entries(vars).forEach(([k, v]) => { val = val.replace(`{${k}}`, v); });
    }
    return val;
  }, [locale]);

  useEffect(() => { document.documentElement.lang = locale; }, [locale]);

  return (
    <I18nContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
